<template>
  <div class="lang-switcher">
    <el-dropdown trigger="click" @command="changeLang">
      <span class="el-dropdown-link">
        🌐 {{ localeLabel }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  computed: {
    localeLabel() { return this.$i18n.locale === 'zh' ? '中文' : 'English' }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    }
  }
}
</script>

<style scoped>
.lang-switcher { cursor:pointer; margin-right:6px }
</style>
